import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import NewBooking from "@/pages/NewBooking";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import CalendarPage from "@/pages/CalendarPage";
import Employees from "@/pages/Employees";
import Invoices from "@/pages/Invoices";
import CustomerPortal from "@/pages/CustomerPortal";
import { Toaster } from "sonner";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  return <Navigate to={user.role === "customer" ? "/portal" : "/dashboard"} replace/>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors/>
        <Routes>
          <Route path="/" element={<RootRedirect/>}/>
          <Route path="/login" element={<Login/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/portal" element={
            <ProtectedRoute roles={["customer"]}><CustomerPortal/></ProtectedRoute>
          }/>
          <Route element={
            <ProtectedRoute roles={["admin", "staff"]}><AdminLayout/></ProtectedRoute>
          }>
            <Route path="/dashboard" element={<Dashboard/>}/>
            <Route path="/customers" element={<Customers/>}/>
            <Route path="/customers/:id" element={<CustomerDetail/>}/>
            <Route path="/booking/new" element={<NewBooking/>}/>
            <Route path="/jobs" element={<Jobs/>}/>
            <Route path="/jobs/:id" element={<JobDetail/>}/>
            <Route path="/calendar" element={<CalendarPage/>}/>
            <Route path="/employees" element={<Employees/>}/>
            <Route path="/invoices" element={<Invoices/>}/>
          </Route>
          <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
